import moment from 'moment';
import { getCurrentPage, loadTrackingCookieName, loadvmLeadformTimeStats } from './vmCookieHandler';
import {
    CATEGORY_CORPORATE,
    CATEGORY_SOCIAL,
    CATEGORY_WEDDING,
    EVEN_TRIGGER_CODE,
    OCCASION_SEARCH_PARAMS,
    ODD_TRIGGER_CODE,
} from '../constants/leadFormConstants';
import {
    loadNoPopupValueFromStorage,
    loadVmEventIdFromStorage,
    loadVmFormCount,
} from './vmStorageHandler';
import isEmpty from 'lodash/isEmpty';
import { ENQUIRY_FORM_TITLE } from '../constants/enquiryFormConst';
import { kebabCase } from 'lodash';
import { DESTINATION_WEDDING_MODEL, MAKE_UP_ARTIST_MODEL, MODELS, VENUE_MODEL } from '../constants/constants';
import { newGtmCustomEvent } from '../modules/utility/gtmTrigger';
import { SEARCH_PAGE_ENUM, VENDOR_PAGE_ENUM, VENUE_PAGE_ENUM } from '../constants/whatsappConst';
import { createSuperEvent } from '../modules/utility/trackingWrapper';

// const AUTO_UNAUTHENTICATED_POPUP_TIME_SEC = 30;
// const CITY_PAGE_URL_LEAD_FORM_DISPLAY = ['gurgaon', 'noida', 'delhi', 'faridabad', 'ghaziabad','jaipur','bangalore', "mumbai", "pune", "pushkar", "alwar", "palwal"];
// const VENDOR_LEAD_FORM_MODELS = [MAKE_UP_ARTIST_MODEL,DESTINATION_WEDDING_MODEL];

// const LEAD_FORM_POPUP_TIME_SLOTS = {
//     '0': [0, 10],
//     '1': [10, 86400],
//     // '2': [60, 70],
// };

// export function checkIfShowLeadForm(isAuthenticated) {
//     let check = checkIfShowBasedOnCookieInfo(isAuthenticated);
//     let timeOnSite = getTimeOnSite();
//     if (check.showPopup) {
//         if (check?.formCount < 3) {
//             let range = LEAD_FORM_POPUP_TIME_SLOTS[check?.formCount?.toString()];
//             return !!(range && timeOnSite > range[0] && timeOnSite < range[1]);
//         }
//         return false;
//     }
//     return false;
// }

// function getTimeOnSite() {
//     let vmleadformstatstime = loadvmLeadformTimeStats();
//     if (vmleadformstatstime) {
//         let initialTime = moment(new Date(parseInt(vmleadformstatstime, 10)));
//         return moment(new Date()).diff(initialTime, 'seconds');
//     }
//     return 0;
// }

// export function checkIfShowBasedOnCookieInfo(isAuthenticated) {
//     let eventid = loadVmEventIdFromStorage();
//     let vmformcount = parseInt(loadVmFormCount()) || 0;
//     let noPopCount = parseInt(loadNoPopupValueFromStorage()) || 0;
//     if (!!eventid || !!noPopCount) {
//         return {
//             showPopup: false,
//             formCount: 0,
//         };
//     } else {
//         if (isAuthenticated) {
//             return {
//                 showPopup: false,
//                 formCount: vmformcount,
//             };
//         } else {
//             return {
//                 showPopup: vmformcount < 2,
//                 formCount: vmformcount,
//             };
//         }
//     }
// }

// function generateLeadFormOpenCode() {
//     let trackingData = loadTrackingCookieName();
//     if (trackingData) {
//         let vmTrackingId = trackingData.vmTrackingId;
//         if (vmTrackingId) {
//             const code_check =
//                 vmTrackingId.charCodeAt(vmTrackingId.length - 1) % 2 === 0
//                     ? EVEN_TRIGGER_CODE
//                     : ODD_TRIGGER_CODE;
//             return code_check;
//         }
//     }
//     return EVEN_TRIGGER_CODE;
// }

// export function getLeadFormWhatToShowManual() {
//     let code = generateLeadFormOpenCode();
//     // return ODD_TRIGGER_CODE;
//     return EVEN_TRIGGER_CODE;
//     // return code === ODD_TRIGGER_CODE ? ODD_TRIGGER_CODE : EVEN_TRIGGER_CODE;
// }

// export function getLeadFormToBeTriggered() {
//     let code = generateLeadFormOpenCode();
//     // return ODD_TRIGGER_CODE;
//     return EVEN_TRIGGER_CODE;
//     // return code === ODD_TRIGGER_CODE ? ODD_TRIGGER_CODE : EVEN_TRIGGER_CODE;
// }

// export function getLeadFormVariables(isAuthenticated) {
//     let showPopup = checkIfShowLeadForm(isAuthenticated);
//     let triggerCode = getLeadFormToBeTriggered();
//     return {
//         showPopup,
//         triggerCode,
//     };
// }

// export function checkIfToShowWhichLeadFormBasedOnCity() {
//     for (let i = 0; i < CITY_PAGE_URL_LEAD_FORM_DISPLAY.length; i++) {
//         if (window.location.pathname.includes(CITY_PAGE_URL_LEAD_FORM_DISPLAY[i])) {
//             return true;
//         }
//     }
//     return false;
// }

// export function getLeadFormType() {
//     let pathname = window.location.pathname;
//     if (pathname === "/collections/gurgaon/destination-wedding-manesar-neemrana") {
//         return DESTINATION_WEDDING_MODEL;
//     }
//     let paths = pathname.split("/")
//     let end = paths.pop()
//     for (let vendor of VENDOR_LEAD_FORM_MODELS) {
//         let model = { ...MODELS[vendor] };
//         if (
//             end === model.search_page_code ||
//             end === model.vendor_page_code
//         ) {
//             return vendor;
//         }
//     }
//     return VENUE_MODEL;
// }

// export function makeRedirectionUrl(event) {
//     let searchPrams = {};
//     let queryParams = {};
//     searchPrams.city = event.city;
//     searchPrams.occasion = OCCASION_SEARCH_PARAMS[event.event_name];
//     if(event.budget_end){
//         queryParams.max_price = event.budget_end;
//     }
//     if(event.budget_start){
//         queryParams.min_price = event.budget_start;
//     }
//     if(event.guests){
//         queryParams.min_capacity = event.guests;;
//     }
//     queryParams.venuetypes = kebabCase(event.venuetype[0].toLowerCase());
//     let url = `/${searchPrams.city}/${searchPrams.occasion}`;
//     let isFirstParam = true;
//     for (const [key, value] of Object.entries(queryParams)) {
//         if (isFirstParam) {
//             url = `${url}?${key}=${value}`;
//             isFirstParam = false;
//         } else {
//             url = `${url}&${key}=${value}`;
//         }
//     }

//     return url;
// }

// export function getEnquiryFormSource(key, source) {
//     return `${key && key !== '' ? key : 'customer'}-${source}-${getDevice()}`;
// }
// export function getEnquiryFormTitle(type) {
//     return ENQUIRY_FORM_TITLE[type]?.formHeading;
// }
// export function getEnquiryFormBtnText(type) {
//     return ENQUIRY_FORM_TITLE[type]?.buttonText;
// }

// export function setNCRLeadFormTriggerCode(
//     currentSlide,
//     selectedVenue,
//     pageSource,
//     leadFormMode
// ) {
//     let currentPage = getCurrentPage()
//     if (currentSlide.questionText == 'Occasion') {
//         try {
//             let selectedOccasionTriggerCode = getLeadFormTriggerCodeForNcr(selectedVenue,pageSource,currentPage,leadFormMode)
//             localStorage.setItem('ncrFormTriggerCode', selectedOccasionTriggerCode);
//         } catch (e) {
//             console.log(e);
//         }
//     }
// }

// export function getNCRLeadFormTriggerCodeBasedOnOccasion(
//     occasionType,
//     selectedVenue,
//     pageSource = 'ncr'
// ) {
//     if (!isEmpty(selectedVenue)) {
//         return `${pageSource}-three`;
//     } else {
//         switch (occasionType.toLowerCase()) {
//             case CATEGORY_WEDDING:
//             case CATEGORY_CORPORATE:
//                 return `${pageSource}-one`;
//             case CATEGORY_SOCIAL:
//                 return `${pageSource}-two`;
//             default:
//                 return `${pageSource}`;
//         }
//     }
// }

// export function getLeadFormTriggerCodeForNcr(selectedVenue, pageSource = 'ncr', currentPage,leadFormType = VENUE_MODEL) {
//     let leadCode = MODELS[leadFormType].lead_type
//     if (currentPage == VENUE_PAGE_ENUM || currentPage == VENDOR_PAGE_ENUM) {
//         return `${pageSource}-${leadCode}-vp`;
//     } else if (currentPage == SEARCH_PAGE_ENUM) {
//         if (isEmpty(selectedVenue)) {
//             return `${pageSource}-${leadCode}-spn`;
//         } else {
//             return `${pageSource}-${leadCode}-spv`;
//         }         
//     } else {
//         return `${pageSource}-${leadCode}-opn`;
//     }
// }

// export function setLeadFormNcrPopUp(
//     leadFormType,
//     leadFormTriggerCode,
//     selectedVenue,
//     currentPage,
//     pageSource
// ) {
//     createSuperEvent({
//         event_name: `${getLeadFormTriggerCodeForNcr(selectedVenue,pageSource,currentPage,leadFormType)}-lead-form-popup-${leadFormTriggerCode ?? 'user'}`,
//         feature_name: `open lead form`,
//         action_name: `lead form opened`,
//     });
//     createSuperEvent({
//         event_name: `${getLeadFormTriggerCodeForNcr(selectedVenue,pageSource,currentPage,leadFormType)}-lead-form-popup`,
//         feature_name: `open lead form`,
//         action_name: `lead form opened`,
//     });
//     createSuperEvent({
//         event_name: `ncr-lead-form-popup-${leadFormTriggerCode ?? 'user'}`,
//         feature_name: `open lead form`,
//         action_name: `lead form opened`,
//     });
//     createSuperEvent({
//         event_name: `ncr-lead-form-popup`,
//         feature_name: `open lead form`,
//         action_name: `lead form opened`,
//     });
// }

// function addLeadFormInteractionTime() {
//     let interaction = sessionStorage.getItem('interaction');
//     if (interaction) {
//         let updateInteraction = JSON.parse(interaction);
//         if (!updateInteraction.lead_form_interaction_time) {
//             updateInteraction.lead_form_interaction_time = moment(new Date()).toISOString();
//             sessionStorage.setItem('interaction', JSON.stringify(updateInteraction));
//         }
//     }
// }

// export function getEventForExitWindow(currentSlide, next) {
//     if (currentSlide.questionText == 'Occasion') {
//         addLeadFormInteractionTime();
//         let selectedOccasion = currentSlide.elements[0].options.filter((item) => item.isSelected);
//         return next(selectedOccasion[0].value);
//     }
// }

// export function getDevice() {
//     if (typeof window !== 'undefined' && window.innerWidth) {
//         return window.innerWidth > 768 ? 'desktop' : 'mobile';
//     } else {
//         return 'unknown';
//     }
// }

// export const getleadType = (model) => {
//     if (!model) return VENUE_MODEL;
//     return MODELS[model]?.lead_type ?? VENUE_MODEL;
// };



const AUTO_UNAUTHENTICATED_POPUP_TIME_SEC = 30;
const CITY_PAGE_URL_LEAD_FORM_DISPLAY = ['gurgaon', 'noida', 'delhi', 'faridabad', 'ghaziabad','jaipur','bangalore', "mumbai", "pune", "pushkar", "alwar", "palwal"];
const VENDOR_LEAD_FORM_MODELS = [MAKE_UP_ARTIST_MODEL,DESTINATION_WEDDING_MODEL];

const LEAD_FORM_POPUP_TIME_SLOTS = {
    '0': [0, 10],
    '1': [10, 86400],
    // '2': [60, 70],
};

export function checkIfShowLeadForm(isAuthenticated) {
    let check = checkIfShowBasedOnCookieInfo(isAuthenticated);
    let timeOnSite = getTimeOnSite();
    if (check.showPopup) {
        if (check?.formCount < 3) {
            let range = LEAD_FORM_POPUP_TIME_SLOTS[check?.formCount?.toString()];
            return !!(range && timeOnSite > range[0] && timeOnSite < range[1]);
        }
        return false;
    }
    return false;
}

function getTimeOnSite() {
    let vmleadformstatstime = loadvmLeadformTimeStats();
    if (vmleadformstatstime) {
        let initialTime = moment(new Date(parseInt(vmleadformstatstime, 10)));
        return moment(new Date()).diff(initialTime, 'seconds');
    }
    return 0;
}

export function checkIfShowBasedOnCookieInfo(isAuthenticated) {
    let eventid = loadVmEventIdFromStorage();
    let vmformcount = parseInt(loadVmFormCount()) || 0;
    let noPopCount = parseInt(loadNoPopupValueFromStorage()) || 0;
    if (!!eventid || !!noPopCount) {
        return {
            showPopup: false,
            formCount: 0,
        };
    } else {
        if (isAuthenticated) {
            return {
                showPopup: false,
                formCount: vmformcount,
            };
        } else {
            return {
                showPopup: vmformcount < 2,
                formCount: vmformcount,
            };
        }
    }
}

function generateLeadFormOpenCode() {
    let trackingData = loadTrackingCookieName();
    if (trackingData) {
        let vmTrackingId = trackingData.vmTrackingId;
        if (vmTrackingId) {
            const code_check =
                vmTrackingId.charCodeAt(vmTrackingId.length - 1) % 2 === 0
                    ? EVEN_TRIGGER_CODE
                    : ODD_TRIGGER_CODE;
            return code_check;
        }
    }
    return EVEN_TRIGGER_CODE;
}

export function getLeadFormWhatToShowManual() {
    let code = generateLeadFormOpenCode();
    // return ODD_TRIGGER_CODE;
    return EVEN_TRIGGER_CODE;
    // return code === ODD_TRIGGER_CODE ? ODD_TRIGGER_CODE : EVEN_TRIGGER_CODE;
}

export function getLeadFormToBeTriggered() {
    let code = generateLeadFormOpenCode();
    // return ODD_TRIGGER_CODE;
    return EVEN_TRIGGER_CODE;
    // return code === ODD_TRIGGER_CODE ? ODD_TRIGGER_CODE : EVEN_TRIGGER_CODE;
}

export function getLeadFormVariables(isAuthenticated) {
    let showPopup = checkIfShowLeadForm(isAuthenticated);
    let triggerCode = getLeadFormToBeTriggered();
    return {
        showPopup,
        triggerCode,
    };
}

export function checkIfToShowWhichLeadFormBasedOnCity() {
    for (let i = 0; i < CITY_PAGE_URL_LEAD_FORM_DISPLAY.length; i++) {
        if (window.location.pathname.includes(CITY_PAGE_URL_LEAD_FORM_DISPLAY[i])) {
            return true;
        }
    }
    return false;
}

export function getLeadFormType() {
    let pathname = window.location.pathname;
    if (pathname === "/collections/gurgaon/destination-wedding-manesar-neemrana") {
        return DESTINATION_WEDDING_MODEL;
    }
    let paths = pathname.split("/")
    let end = paths.pop()
    for (let vendor of VENDOR_LEAD_FORM_MODELS) {
        let model = { ...MODELS[vendor] };
        if (
            end === model.search_page_code ||
            end === model.vendor_page_code
        ) {
            return vendor;
        }
    }
    return VENUE_MODEL;
}

export function makeRedirectionUrl(event) {
    let searchPrams = {};
    let queryParams = {};
    searchPrams.city = event.city;
    searchPrams.occasion = OCCASION_SEARCH_PARAMS[event.event_name];
    if(event.budget_end){
        queryParams.max_price = event.budget_end;
    }
    if(event.budget_start){
        queryParams.min_price = event.budget_start;
    }
    if(event.guests){
        queryParams.min_capacity = event.guests;;
    }
    queryParams.venuetypes = kebabCase(event.venuetype[0].toLowerCase());
    let url = `/${searchPrams.city}/${searchPrams.occasion}`;
    let isFirstParam = true;
    for (const [key, value] of Object.entries(queryParams)) {
        if (isFirstParam) {
            url = `${url}?${key}=${value}`;
            isFirstParam = false;
        } else {
            url = `${url}&${key}=${value}`;
        }
    }

    return url;
}

export function getEnquiryFormSource(key, source) {
    return `${key && key !== '' ? key : 'customer'}-${source}-${getDevice()}`;
}
export function getEnquiryFormTitle(type) {
    return ENQUIRY_FORM_TITLE[type]?.formHeading;
}
export function getEnquiryFormBtnText(type) {
    return ENQUIRY_FORM_TITLE[type]?.buttonText;
}

export function setNCRLeadFormTriggerCode(
    currentSlide,
    selectedVenue,
    pageSource,
    leadFormMode
) {
    let currentPage = getCurrentPage()
    if (currentSlide.questionText == 'Occasion') {
        try {
            let selectedOccasionTriggerCode = getLeadFormTriggerCodeForNcr(selectedVenue,pageSource,currentPage,leadFormMode)
            localStorage.setItem('ncrFormTriggerCode', selectedOccasionTriggerCode);
        } catch (e) {
            console.log(e);
        }
    }
}

export function getNCRLeadFormTriggerCodeBasedOnOccasion(
    occasionType,
    selectedVenue,
    pageSource = 'ncr'
) {
    if (!isEmpty(selectedVenue)) {
        return `${pageSource}-three`;
    } else {
        switch (occasionType.toLowerCase()) {
            case CATEGORY_WEDDING:
            case CATEGORY_CORPORATE:
                return `${pageSource}-one`;
            case CATEGORY_SOCIAL:
                return `${pageSource}-two`;
            default:
                return `${pageSource}`;
        }
    }
}

export function getLeadFormTriggerCodeForNcr(selectedVenue, pageSource = 'ncr', currentPage,leadFormType = VENUE_MODEL) {
    let leadCode = MODELS[leadFormType].lead_type
    if (currentPage == VENUE_PAGE_ENUM || currentPage == VENDOR_PAGE_ENUM) {
        return `${pageSource}-${leadCode}-vp`;
    } else if (currentPage == SEARCH_PAGE_ENUM) {
        if (isEmpty(selectedVenue)) {
            return `${pageSource}-${leadCode}-spn`;
        } else {
            return `${pageSource}-${leadCode}-spv`;
        }         
    } else {
        return `${pageSource}-${leadCode}-opn`;
    }
}

export function setLeadFormNcrPopUp(
    leadFormType,
    leadFormTriggerCode,
    selectedVenue,
    currentPage,
    pageSource
) {
    createSuperEvent({
        event_name: `${getLeadFormTriggerCodeForNcr(selectedVenue,pageSource,currentPage,leadFormType)}-lead-form-popup-${leadFormTriggerCode ?? 'user'}`,
        feature_name: `open lead form`,
        action_name: `lead form opened`,
    });
    createSuperEvent({
        event_name: `${getLeadFormTriggerCodeForNcr(selectedVenue,pageSource,currentPage,leadFormType)}-lead-form-popup`,
        feature_name: `open lead form`,
        action_name: `lead form opened`,
    });
    createSuperEvent({
        event_name: `ncr-lead-form-popup-${leadFormTriggerCode ?? 'user'}`,
        feature_name: `open lead form`,
        action_name: `lead form opened`,
    });
    createSuperEvent({
        event_name: `ncr-lead-form-popup`,
        feature_name: `open lead form`,
        action_name: `lead form opened`,
    });
}

function addLeadFormInteractionTime() {
    let interaction = sessionStorage.getItem('interaction');
    if (interaction) {
        let updateInteraction = JSON.parse(interaction);
        if (!updateInteraction.lead_form_interaction_time) {
            updateInteraction.lead_form_interaction_time = moment(new Date()).toISOString();
            sessionStorage.setItem('interaction', JSON.stringify(updateInteraction));
        }
    }
}

export function getEventForExitWindow(currentSlide, next) {
    if (currentSlide.questionText == 'Occasion') {
        addLeadFormInteractionTime();
        let selectedOccasion = currentSlide.elements[0].options.filter((item) => item.isSelected);
        return next(selectedOccasion[0].value);
    }
}

export function getDevice() {
    if (typeof window !== 'undefined' && window.innerWidth) {
        return window.innerWidth > 768 ? 'desktop' : 'mobile';
    } else {
        return 'unknown';
    }
}

export const getleadType = (model) => {
    if (!model) return VENUE_MODEL;
    return MODELS[model]?.lead_type ?? VENUE_MODEL;
};
